import React from 'react';
import DataCollection from '../../shared/DataCollection.js';
import { useTranslation } from 'react-i18next';

const SYSTEM_ACCOUNT = '000000000000000000000000';

export const ListLotFields = () => {
  const { t } = useTranslation();

  const columns = [
    {
      name:     t('lot_field_friendly_name'),
      selector: row => row.friendly_name,
      sortable: true,
    },
    {
      name:     t('lot_field_aliases'),
      selector: row => (row.aliases || []).join(', '),
      cell:     row => <span style={{ color: '#666', fontSize: 13 }}>{(row.aliases || []).join(', ')}</span>,
    },
    {
      name:     t('breed_type'),
      selector: row => row.account === SYSTEM_ACCOUNT ? t('lot_field_type_system') : t('lot_field_type_custom'),
      sortable: true,
      cell:     row => (
        <span style={{
          fontSize: 11,
          fontWeight: 600,
          color: row.account === SYSTEM_ACCOUNT ? '#5d8a3a' : '#b8862f',
        }}>
          {row.account === SYSTEM_ACCOUNT ? t('lot_field_type_system') : t('lot_field_type_custom')}
        </span>
      ),
    },
  ];

  return (
    <DataCollection
      collection="lots.custom_fields"
      columns={columns}
      sortField={1}
    />
  );
};

export default ListLotFields;
